import React from 'react'
import { Helmet } from 'react-helmet'
import Navigation from '../components/navigation'
import Text from '../components/text'
import Footer from '../components/footer'
import './ueber-uns.css'

const UeberUns = (props) => {
  return (
    <div className="ueber-uns-container">
      <Helmet>
        <title>Über uns</title>
        <meta property="og:title" content="Über uns -                                                                                                                                                                                                                                                                                                                                                                                         " />
        <link
          rel="canonical"
          href="https://all-obedient-rhinoceros-5cbetl.teleporthq.app/ueber-uns"
        />
      </Helmet>
      <Navigation rootClassName="navigationroot-class-name"></Navigation>
      <Text rootClassName="textroot-class-name"></Text>
      <Footer></Footer>
    </div>
  )
}

export default UeberUns
